module.exports = __webpack_public_path__ + "static/media/Kessel105-Light.af756acf.woff2";